import { Link } from "react-router-dom";
import { Globe } from "lucide-react";

/** Shared shell for public trust pages (/methodology, /privacy, /terms, /disclaimer). */
export const PublicPageShell = ({ overline, title, updated, children, testId }) => (
  <div className="min-h-screen bg-background text-white" data-testid={testId}>
    <header className="sticky top-0 z-40 border-b border-white/10 backdrop-blur-xl bg-black/60">
      <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="trust-page-brand-link">
          <span className="w-7 h-7 bg-primary flex items-center justify-center rounded-sm">
            <Globe className="w-4 h-4 text-white" />
          </span>
          <span className="font-heading font-black tracking-tighter text-lg text-white">
            SphereInvest<span className="text-primary"> AI</span>
          </span>
        </Link>
        <Link to="/login" className="text-sm text-muted-foreground hover:text-white transition-colors duration-150">
          Sign in
        </Link>
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-6 py-16">
      <div className="overline-label mb-3">{overline}</div>
      <h1 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl leading-[1.05] mb-2">{title}</h1>
      {updated && <p className="text-xs font-mono text-muted-foreground mb-10">Last updated: {updated}</p>}
      <div className="trust-prose space-y-6">{children}</div>
    </main>

    <footer className="border-t border-border">
      <div className="max-w-3xl mx-auto px-6 py-8 space-y-3">
        <nav className="flex flex-wrap gap-x-5 gap-y-1 text-xs font-mono text-muted-foreground">
          <Link to="/" className="hover:text-white">Home</Link>
          <Link to="/methodology" className="hover:text-white">Methodology</Link>
          <Link to="/privacy" className="hover:text-white">Privacy</Link>
          <Link to="/terms" className="hover:text-white">Terms</Link>
          <Link to="/disclaimer" className="hover:text-white">Disclaimer</Link>
        </nav>
        <p className="text-[11px] font-mono text-muted-foreground/70 leading-relaxed">
          SphereInvest AI is an investment research and analytical technology platform. It does not execute trades,
          hold client funds or provide personalised financial advice. Information provided through the platform is for
          research and educational purposes only. Capital at risk: the value of investments can fall as well as rise.
        </p>
        <p className="text-[11px] font-mono text-muted-foreground/50 leading-relaxed">
          SphereInvest AI is operated by Three Spheres Healthcare Limited, a company registered in England and Wales
          (Company No. 14029879). Contact:{" "}
          <a href="mailto:info@threesphereshealthcare.org" className="hover:text-muted-foreground">info@threesphereshealthcare.org</a>.
        </p>
      </div>
    </footer>
  </div>
);

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-heading font-bold text-lg text-white tracking-tight mb-3">{heading}</h2>
    <div className="space-y-3 text-sm text-gray-300 leading-relaxed">{children}</div>
  </section>
);
